import en from './en'
import cn from './cn'
export default {
  // ********************************************************
  //
  // SIMPLIFIED CHINESE
  //
  // ********************************************************
  cn: cn,
  // ********************************************************
  //
  // ENGLISH
  //
  // ********************************************************
  en: en,
}
